/**
 * 유튜브 URL에서 비디오 ID를 추출하는 함수
 * @param url 유튜브 URL
 * @returns 비디오 ID 또는 null
 */
export const extractYoutubeVideoId = (url: string): string | null => {
  if (!url) return null;

  // URL 정규화 (공백 제거)
  const normalizedUrl = url.trim();

  // 다양한 유튜브 URL 형식 지원
  const patterns = [
    // https://www.youtube.com/watch?v=VIDEO_ID (가장 일반적)
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/,
    // 모바일 URL: m.youtube.com/watch?v=VIDEO_ID
    /(?:m\.youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/,
  ];

  for (const pattern of patterns) {
    const match = normalizedUrl.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
};

/**
 * 유튜브 URL인지 확인하는 함수
 * @param text 확인할 텍스트
 * @returns 유튜브 URL 여부
 */
export const isYoutubeUrl = (text: string): boolean => {
  if (!text) return false;
  return extractYoutubeVideoId(text.trim()) !== null;
};

/**
 * 유튜브 임베드 URL 생성
 * @param videoId 유튜브 비디오 ID
 * @returns 임베드 URL
 */
export const getYoutubeEmbedUrl = (videoId: string): string => {
  return `https://www.youtube.com/embed/${videoId}`;
};

